export default "__VITE_ASSET__NZX7Yp7b__"